/**
 * The order of the tables on the room's list, after a drag.
 *
 * Pure, with no React, so CRA's jest can test it. What is left of the packed
 * board's layout maths: the list does not pack, it only has an order.
 */

export interface ListItem {
  id: number;
  position: number;
  pinned: boolean;
}

/** Positions after a drag, as {id: position} — the caller PATCHes these. Only
 *  what moved is returned, so a reorder is one or two writes rather than a
 *  rewrite of the list. */
export function reorder(items: ListItem[], id: number, toIndex: number): Record<number, number> {
  const order = items
    .filter(i => i.pinned)
    .slice()
    .sort((a, b) => a.position - b.position || a.id - b.id);
  const from = order.findIndex(i => i.id === id);
  if (from < 0) return {};
  const target = Math.max(0, Math.min(toIndex, order.length - 1));
  if (from === target) return {};
  const [moved] = order.splice(from, 1);
  order.splice(target, 0, moved);
  const out: Record<number, number> = {};
  order.forEach((item, i) => {
    if (item.position !== i) out[item.id] = i;
  });
  return out;
}

/** WHERE A DROP LANDS, from the card it is over and which side of it. The
 *  index `reorder` wants - counted with the dragged card already lifted out -
 *  or null when that slot is where the card already sits, so no line shows. */
export function dropIndex(from: number, over: number, side: 'before' | 'after'): number | null {
  const slot = side === 'after' ? over + 1 : over;
  if (from < 0 || slot === from || slot === from + 1) return null;
  return slot > from ? slot - 1 : slot;
}
